import { ButtonV2, Spinner, TooltipV2 } from '@cimplico/components';
import { DocumentArrowUpIcon } from '@heroicons/react/24/outline';
import { useRef } from 'react';
import { asyncToast } from '../../../../components/toast/Toast';
import { useCreateDocument } from '../../../../queries/use-create-document';
import FileInput from '../../../files/FileInput';
type NewDocumentProps = {
    disabled?: boolean;
    folderId: string;
    onCreate?: (fileId?: string | undefined) => void;
};

function NewDocument({ disabled, folderId, onCreate }: NewDocumentProps): JSX.Element {
    const fileRef = useRef<HTMLInputElement | null>(null);

    const createDocumentQuery = useCreateDocument();

    async function handleCreate(files: File[]): Promise<void> {
        const file = files[0];

        if (!file) {
            return;
        }

        createDocumentQuery.mutate(
            { file, parentFolderId: folderId },
            {
                onSuccess: (res) => {
                    if (onCreate) {
                        onCreate(res.id);
                    }
                },
                onError: () => {},
            }
        );
    }

    return (
        <div>
            <FileInput multiple={false} innerRef={fileRef} onSelect={handleCreate} />
            {createDocumentQuery.isLoading ? (
                <div className="pr-3.5">
                    <Spinner size="xs" />
                </div>
            ) : (
                <TooltipV2 message="Upload a file" disabled={disabled}>
                    <ButtonV2
                        size="sm"
                        type="hollow"
                        leftIcon={<DocumentArrowUpIcon />}
                        onClick={(): void => fileRef.current?.click()}
                        isDisabled={disabled}
                    />
                </TooltipV2>
            )}
        </div>
    );
}

export default NewDocument;
